import { library, IconDefinition, IconLookup, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { IconName } from '@fortawesome/free-solid-svg-icons';

export const facAcUnit: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'ac-unit' as IconName,
  icon: [
    40,
    40,
    [],
    'none',
    'M35.333,17h-6.95l5.4-5.4-2.35-2.367L23.667,17H20.333V13.667L28.1,5.9,25.733,3.55l-5.4,5.4V2H17V8.95l-5.4-5.4L9.233,5.9,17,13.667V17H13.667L5.9,9.233,3.55,11.6,8.95,17H2v3.333H8.95l-5.4,5.4L5.9,28.1l7.767-7.767H17v3.333L9.233,31.433l2.367,2.35,5.4-5.4v6.95h3.333v-6.95l5.4,5.4,2.367-2.35-7.767-7.767V20.333h3.333L31.433,28.1l2.35-2.367-5.4-5.4h6.95Z'
  ]
};
library.add(facAcUnit);

export const facBed: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'bed' as IconName,
  icon: [
    40,
    40,
    [],
    'none',
    'M11,18.667a5,5,0,1,0-5-5A4.993,4.993,0,0,0,11,18.667ZM11,12a1.667,1.667,0,1,1-1.667,1.667A1.672,1.672,0,0,1,11,12ZM31,7H17.667V20.333H4.333V7H1V23.667H37.667v-10A6.665,6.665,0,0,0,31,7Zm3.333,13.333H21v-10H31a3.343,3.343,0,0,1,3.333,3.333Z'
  ]
};
library.add(facBed);

export const facBus: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'bus' as IconName,
  icon: [
    40,
    40,
    [],
    'none',
    'M27.667,5H4.333A3.332,3.332,0,0,0,1,8.333v15H4.333a5,5,0,0,0,10,0h10a5,5,0,0,0,10,0h3.333V15ZM24.333,8.333H26l5,5H24.333Zm-10,0H21v5H14.333Zm-10,0H11v5H4.333Zm5,17.083a2.083,2.083,0,1,1,2.083-2.083A2.084,2.084,0,0,1,9.333,25.417Zm20,0a2.083,2.083,0,1,1,2.083-2.083A2.084,2.084,0,0,1,29.333,25.417Zm5-5.417h-1.3a4.94,4.94,0,0,0-7.4,0h-12.6a4.94,4.94,0,0,0-7.4,0h-1.3V16.667h30Z'
  ]
};
library.add(facBus);

export const facSettings: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'settings' as IconName,
  icon: [
    40,
    40,
    [],
    'none',
    'M30.87,20.3a12.988,12.988,0,0,0,.117-1.633,12.989,12.989,0,0,0-.117-1.633l3.517-2.75a.841.841,0,0,0,.2-1.067L31.253,7.45a.832.832,0,0,0-.733-.417.779.779,0,0,0-.283.05L26.086,8.75A12.177,12.177,0,0,0,23.27,7.117L22.636,2.7A.813.813,0,0,0,21.82,2H15.153a.813.813,0,0,0-.817.7L13.7,7.117A12.8,12.8,0,0,0,10.886,8.75L6.736,7.083a.944.944,0,0,0-.3-.05.825.825,0,0,0-.717.417L2.386,13.217a.822.822,0,0,0,.2,1.067L6.1,17.033a13.218,13.218,0,0,0-.117,1.633A13.218,13.218,0,0,0,6.1,20.3L2.586,23.05a.841.841,0,0,0-.2,1.067L5.72,29.883a.832.832,0,0,0,.733.417.779.779,0,0,0,.283-.05l4.15-1.667A12.177,12.177,0,0,0,13.7,30.217l.633,4.417a.813.813,0,0,0,.817.7H21.82a.813.813,0,0,0,.817-.7l.633-4.417a12.8,12.8,0,0,0,2.817-1.633l4.15,1.667a.944.944,0,0,0,.3.05.825.825,0,0,0,.717-.417l3.333-5.767a.841.841,0,0,0-.2-1.067Zm-3.3-2.85a8.9,8.9,0,0,1,.083,1.217c0,.35-.033.717-.083,1.217l-.233,1.883,1.483,1.167,1.8,1.4L29.453,26.35l-2.117-.85L25.6,24.8l-1.5,1.133A9.761,9.761,0,0,1,22.02,27.15l-1.767.717-.267,1.883L19.653,32H17.32L17,29.75l-.267-1.883L14.97,27.15a9.456,9.456,0,0,1-2.05-1.183L11.4,24.8l-1.767.717-2.117.85L6.353,24.35l1.8-1.4,1.483-1.167L9.4,19.9c-.05-.517-.083-.9-.083-1.233s.033-.717.083-1.217l.233-1.883L8.153,14.4,6.353,13,7.52,10.983l2.117.85,1.733.7,1.5-1.133a9.761,9.761,0,0,1,2.083-1.217l1.767-.717.267-1.883.333-2.25h2.317l.317,2.25.267,1.883,1.767.717a9.456,9.456,0,0,1,2.05,1.183l1.517,1.167,1.767-.717,2.117-.85L30.6,12.983,28.82,14.4l-1.483,1.167.233,1.883ZM18.486,12a6.667,6.667,0,1,0,6.667,6.667A6.665,6.665,0,0,0,18.486,12Zm0,10a3.333,3.333,0,1,1,3.333-3.333A3.343,3.343,0,0,1,18.486,22Z'
  ]
};
library.add(facSettings);

export const facShower: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'shower' as IconName,
  icon: [
    40,
    40,
    [],
    'none',
    'M11.667,26.333A1.667,1.667,0,1,1,10,24.667,1.672,1.672,0,0,1,11.667,26.333Zm5-1.667a1.667,1.667,0,1,0,1.667,1.667A1.672,1.672,0,0,0,16.667,24.667Zm6.667,0A1.667,1.667,0,1,0,25,26.333,1.672,1.672,0,0,0,23.333,24.667Zm5-6.667v3.333H5V18A11.659,11.659,0,0,1,15,6.467V3h3.333V6.467A11.659,11.659,0,0,1,28.333,18ZM25,18A8.333,8.333,0,0,0,8.333,18ZM10,29.667a1.667,1.667,0,1,0,1.667,1.667A1.672,1.672,0,0,0,10,29.667Zm6.667,0a1.667,1.667,0,1,0,1.667,1.667A1.672,1.672,0,0,0,16.667,29.667Zm6.667,0A1.667,1.667,0,1,0,25,31.333,1.672,1.672,0,0,0,23.333,29.667Z'
  ]
};
library.add(facShower);

export const facToilet: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'toilet' as IconName,
  icon: [
    40,
    40,
    [],
    'none',
    'm29.904 18.047-3.4883.29297s.43012 4.4191-3.4492 6.3926a1.7502 1.7502 0 00-.95508 1.6504c.21433 4.1298.26668 5.3911.31055 6.3711h-3.3184v3.5h5.1562a1.7502 1.7502 0 001.748-1.8262s-.1417-3.0696-.35352-7.2441c4.7296-3.2159 4.3496-9.1367 4.3496-9.1367zm-10.904-14.295v3.5h7.9297l-1.4688 8.6504 3.4512.58398 1.8125-10.693a1.7502 1.7502 0 00-1.7246-2.041zm-8.9395 14.295s-.37998 5.9208 4.3496 9.1367c-.21182 4.1745-.35352 7.2441-.35352 7.2441a1.7502 1.7502 0 001.748 1.8262h5.1562v-3.5h-3.3184c.04386-.98004.09621-2.2413.31055-6.3711a1.7502 1.7502 0 00-.95508-1.6504c-3.8793-1.9735-3.4492-6.3926-3.4492-6.3926zm.93945-14.295a1.7502 1.7502 0 00-1.7246 2.041l1.8125 10.693 3.4512-.58398-1.4688-8.6504h6.9297v-3.5zm9 13.598c-1.7148 0-3.4006.22754-4.7467.6407-.20698.06353-.3957.12817-.56699.19243.17129.06426.36001.1289.56699.19243 1.3461.41316 3.0318.6407 4.7467.6407s3.4006-.22754 4.7467-.6407c.20698-.06353.3957-.12817.56699-.19243-.17129-.06426-.36001-.1289-.56699-.19243-1.3461-.41316-3.0318-.6407-4.7467-.6407m0-3.5c5.5228 0 10 1.94 10 4.3331s-4.4772 4.3331-10 4.3331-10-1.94-10-4.3331 4.4772-4.3331 10-4.3331zm0 5e-6c5.523 0 10 1.94 10 4.333s-4.477 4.333-10 4.333-10-1.94-10-4.333 4.477-4.333 10-4.333z'
  ]
};
library.add(facToilet);

export const facUsers: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'users' as IconName,
  icon: [
    650,
    650,
    [],
    'none',
    'M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z'
  ]
};
library.add(facUsers);

export const facPeople: IconDefinition & IconLookup = {
  prefix: 'fac' as IconPrefix,
  iconName: 'people' as IconName,
  icon: [
    24,
    24,
    [],
    'none',
    'm12.5 11.5a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5zm1.5 10.5v-4h1v-4a1.51 1.51 0 00-1.5-1.5h-2a1.51 1.51 0 00-1.5 1.5v4h1v4zm-9.5-16a2 2 0 10-2-2 1.99 1.99 0 002 2zm2 16v-7h1.5v-6a2.01 2.01 0 00-2-2h-3a2.01 2.01 0 00-2 2v6h1.5v7z'
  ]
};
library.add(facPeople);
